<template>
    <div class="select_code">
        <div class="navigation">
            <div class="left" @click="goBack"><i class="icon-back"/></div>
            <div class="content">选择国家或地区</div>
        </div>
        <div class="navigation_back"></div>

        <div class="country_item" v-for="(item,index) in countries" :key="index">
            <div :id="'section_' + item.initial" class="anchor">
                <div class="section_title">{{item.initial}}</div>
            </div>
            <div class="country_detail_item" v-for="(section,index) in item.sections" :key="index"
                 @click="countryClick(section.tel)">
                <div class="country_name">
                    {{section.name}}
                </div>
                <div class="country_tel">+{{section.tel}}</div>
                <div class="clear"></div>
                <div class="line"></div>
            </div>
        </div>

        <div class="country_indexs">
            <div class="country_indexs_item" v-for="(item,index) in letters" :key="index"
                 @click="scrollToPositin(item)">
                {{item}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "selectCode",
        data() {
            return {
                lastRouter: "",
                selectTel: "",
                letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
                countries: [{
                    "initial": "A", "sections": [
                        {"name": "阿富汗", "tel": "93"},
                        {"name": "阿尔巴尼亚", "tel": "355"},
                        {"name": "阿尔及利亚", "tel": "213"},
                        {"name": "阿根廷", "tel": "54"},
                        {"name": "阿拉伯联合酋长国", "tel": "971"},
                        {"name": "阿鲁巴", "tel": "297"},
                        {"name": "阿曼", "tel": "968"},
                        {"name": "阿塞拜疆", "tel": "994"},
                        {"name": "埃及", "tel": "20"},
                        {"name": "埃塞俄比亚", "tel": "251"},
                        {"name": "爱尔兰", "tel": "353"},
                        {"name": "中国澳门", "tel": "853"},
                        {"name": "爱沙尼亚", "tel": "372"},
                        {"name": "安道尔", "tel": "376"},
                        {"name": "安哥拉", "tel": "244"},
                        {"name": "安圭拉", "tel": "1264"},
                        {"name": "安提瓜和巴布达", "tel": "1268"},
                        {"name": "奥地利", "tel": "43"},
                        {"name": "澳大利亚", "tel": "61"}
                    ]
                },
                    {
                        "initial": "B", "sections": [
                            {"name": "巴巴多斯", "tel": "1246"},
                            {"name": "巴布亚新几内亚", "tel": "675"},
                            {"name": "巴哈马", "tel": "1242"},
                            {"name": "巴基斯坦", "tel": "92"},
                            {"name": "巴拉圭", "tel": "595"},
                            {"name": "巴勒斯坦", "tel": "970"},
                            {"name": "巴林", "tel": "973"},
                            {"name": "巴拿马", "tel": "507"},
                            {"name": "巴西", "tel": "55"},
                            {"name": "白俄罗斯", "tel": "375"},
                            {"name": "百慕大群岛", "tel": "1441"},
                            {"name": "保加利亚", "tel": "359"},
                            {"name": "贝宁", "tel": "229"},
                            {"name": "比利时", "tel": "32"},
                            {"name": "冰岛", "tel": "354"},
                            {"name": "波多黎各", "tel": "1787"},
                            {"name": "波兰", "tel": "48"},
                            {"name": "波斯尼亚和黑塞哥维那", "tel": "387"},
                            {"name": "玻利维亚", "tel": "591"},
                            {"name": "伯利兹", "tel": "501"},
                            {"name": "博茨瓦纳", "tel": "267"},
                            {"name": "不丹", "tel": "975"},
                            {"name": "布基纳法索", "tel": "226"},
                            {"name": "布隆迪", "tel": "257"},
                        ]
                    },
                    {
                        "initial": "C", "sections": [
                            {"name": "赤道几内亚", "tel": "240"},
                        ]
                    },
                    {
                        "initial": "D", "sections": [
                            {"name": "丹麦", "tel": "45"},
                            {"name": "德国", "tel": "49"},
                            {"name": "东帝汶", "tel": "670"},
                            {"name": "多哥", "tel": "228"},
                            {"name": "多米尼加", "tel": "1767"},
                            {"name": "多米尼加共和国", "tel": "1809"},
                        ]
                    },
                    {
                        "initial": "E", "sections": [
                            {"name": "俄罗斯", "tel": "7"},
                            {"name": "厄瓜多尔", "tel": "593"},
                            {"name": "厄立特里亚", "tel": "291"},
                        ]
                    },
                    {
                        "initial": "F", "sections": [
                            {"name": "法国", "tel": "33"},
                            {"name": "法罗群岛", "tel": "298"},
                            {"name": "法属波利尼西亚", "tel": "689"},
                            {"name": "法属圭亚那", "tel": "594"},
                            {"name": "菲律宾", "tel": "63"},
                            {"name": "斐济", "tel": "679"},
                            {"name": "芬兰", "tel": "358"},
                        ]
                    },
                    {
                        "initial": "G", "sections": [
                            {"name": "冈比亚", "tel": "220"},
                            {"name": "刚果共和国", "tel": "242"},
                            {"name": "刚果民主共和国", "tel": "243"},
                            {"name": "哥伦比亚", "tel": "57"},
                            {"name": "哥斯达黎加", "tel": "506"},
                            {"name": "格林纳达", "tel": "1473"},
                            {"name": "格陵兰岛", "tel": "299"},
                            {"name": "格鲁吉亚", "tel": "995"},
                            {"name": "古巴", "tel": "53"},
                            {"name": "瓜德罗普岛", "tel": "590"},
                            {"name": "瓜地马拉", "tel": "502"},
                            {"name": "关岛", "tel": "1671"},
                            {"name": "圭亚那", "tel": "592"},
                        ]
                    },
                    {
                        "initial": "H", "sections": [
                            {"name": "哈萨克斯坦", "tel": "7"},
                            {"name": "海地", "tel": "509"},
                            {"name": "韩国", "tel": "82"},
                            {"name": "荷兰", "tel": "31"},
                            {"name": "黑山", "tel": "382"},
                            {"name": "洪都拉斯", "tel": "504"},
                        ]
                    },
                    {
                        "initial": "J", "sections": [
                            {"name": "基里巴斯", "tel": "686"},
                            {"name": "吉布提", "tel": "253"},
                            {"name": "吉尔吉斯斯坦", "tel": "996"},
                            {"name": "几内亚", "tel": "224"},
                            {"name": "几内亚比绍共和国", "tel": "245"},
                            {"name": "加拿大", "tel": "1"},
                            {"name": "加纳", "tel": "233"},
                            {"name": "加蓬", "tel": "241"},
                            {"name": "柬埔寨", "tel": "855"},
                            {"name": "捷克", "tel": "420"},
                            {"name": "津巴布韦", "tel": "263"},
                        ]
                    },
                    {
                        "initial": "K", "sections": [
                            {"name": "喀麦隆", "tel": "237"},
                            {"name": "卡塔尔", "tel": "974"},
                            {"name": "开曼群岛", "tel": "1345"},
                            {"name": "开普", "tel": "238"},
                            {"name": "科摩罗", "tel": "269"},
                            {"name": "科威特", "tel": "965"},
                            {"name": "克罗地亚", "tel": "385"},
                            {"name": "肯尼亚", "tel": "254"},
                            {"name": "库克群岛", "tel": "682"},
                            {"name": "库拉索", "tel": "599"},
                        ]
                    },
                    {
                        "initial": "L", "sections": [
                            {"name": "拉脱维亚", "tel": "371"},
                            {"name": "莱索托", "tel": "266"},
                            {"name": "老挝", "tel": "856"},
                            {"name": "黎巴嫩", "tel": "961"},
                            {"name": "立陶宛", "tel": "370"},
                            {"name": "利比里亚", "tel": "231"},
                            {"name": "利比亚", "tel": "218"},
                            {"name": "列支敦士登", "tel": "423"},
                            {"name": "留尼汪", "tel": "262"},
                            {"name": "卢森堡", "tel": "352"},
                            {"name": "卢旺达", "tel": "250"},
                            {"name": "罗马尼亚", "tel": "40"},
                        ]
                    },
                    {
                        "initial": "M", "sections": [
                            {"name": "马达加斯加", "tel": "261"},
                            {"name": "马尔代夫", "tel": "960"},
                            {"name": "马耳他", "tel": "356"},
                            {"name": "马拉维", "tel": "265"},
                            {"name": "马来西亚", "tel": "60"},
                            {"name": "马里", "tel": "223"},
                            {"name": "马其顿", "tel": "389"},
                            {"name": "马提尼克", "tel": "596"},
                            {"name": "马约特", "tel": "269"},
                            {"name": "毛里求斯", "tel": "230"},
                            {"name": "毛里塔尼亚", "tel": "222"},
                            {"name": "美国", "tel": "1"},
                            {"name": "美属萨摩亚", "tel": "1684"},
                            {"name": "美属维尔京群岛", "tel": "1284"},
                            {"name": "蒙古", "tel": "976"},
                            {"name": "蒙特塞拉特岛", "tel": "1664"},
                            {"name": "孟加拉国", "tel": "880"},
                            {"name": "秘鲁", "tel": "51"},
                            {"name": "缅甸", "tel": "95"},
                            {"name": "摩尔多瓦", "tel": "373"},
                            {"name": "摩洛哥", "tel": "212"},
                            {"name": "摩纳哥", "tel": "377"},
                            {"name": "莫桑比克", "tel": "258"},
                            {"name": "墨西哥", "tel": "52"},
                        ]
                    },
                    {
                        "initial": "N", "sections": [
                            {"name": "纳米比亚", "tel": "264"},
                            {"name": "南非", "tel": "27"},
                            {"name": "尼加拉瓜", "tel": "505"},
                            {"name": "尼泊尔", "tel": "977"},
                            {"name": "尼日尔", "tel": "227"},
                            {"name": "尼日利亚", "tel": "234"},
                            {"name": "挪威", "tel": "47"},
                        ]
                    },
                    {
                        "initial": "P", "sections": [
                            {"name": "帕劳", "tel": "680"},
                            {"name": "葡萄牙", "tel": "351"},
                        ]
                    },
                    {
                        "initial": "R", "sections": [
                            {"name": "日本", "tel": "81"},
                            {"name": "瑞典", "tel": "46"},
                            {"name": "瑞士", "tel": "41"},
                        ]
                    },
                    {
                        "initial": "S", "sections": [
                            {"name": "萨尔瓦多", "tel": "503"},
                            {"name": "萨摩亚", "tel": "685"},
                            {"name": "塞尔维亚", "tel": "381"},
                            {"name": "塞拉利昂", "tel": "232"},
                            {"name": "塞内加尔", "tel": "221"},
                            {"name": "塞浦路斯", "tel": "357"},
                            {"name": "塞舌尔", "tel": "248"},
                            {"name": "沙特阿拉伯", "tel": "966"},
                            {"name": "圣彼埃尔和密克隆岛", "tel": "508"},
                            {"name": "圣多美和普林西比", "tel": "239"},
                            {"name": "圣基茨和尼维斯", "tel": "1869"},
                            {"name": "圣露西亚", "tel": "1758"},
                            {"name": "圣马丁岛（荷兰部分）", "tel": "1721"},
                            {"name": "圣马力诺", "tel": "378"},
                            {"name": "圣文森特和格林纳丁斯", "tel": "1784"},
                            {"name": "斯里兰卡", "tel": "94"},
                            {"name": "斯洛伐克", "tel": "421"},
                            {"name": "斯洛文尼亚", "tel": "386"},
                            {"name": "斯威士兰", "tel": "268"},
                            {"name": "苏丹", "tel": "249"},
                            {"name": "苏里南", "tel": "597"},
                            {"name": "所罗门群岛", "tel": "677"},
                            {"name": "索马里", "tel": "252"},
                        ]
                    },
                    {
                        "initial": "T", "sections": [
                            {"name": "中国台湾", "tel": "886"},
                            {"name": "塔吉克斯坦", "tel": "992"},
                            {"name": "泰国", "tel": "66"},
                            {"name": "坦桑尼亚", "tel": "255"},
                            {"name": "汤加", "tel": "676"},
                            {"name": "特克斯和凯科斯群岛", "tel": "1649"},
                            {"name": "特立尼达和多巴哥", "tel": "1868"},
                            {"name": "突尼斯", "tel": "216"},
                            {"name": "土耳其", "tel": "90"},
                            {"name": "土库曼斯坦", "tel": "993"},
                        ]
                    },
                    {
                        "initial": "W", "sections": [
                            {"name": "瓦努阿图", "tel": "678"},
                            {"name": "委内瑞拉", "tel": "58"},
                            {"name": "文莱", "tel": "673"},
                            {"name": "乌干达", "tel": "256"},
                            {"name": "乌克兰", "tel": "380"},
                            {"name": "乌拉圭", "tel": "598"},
                            {"name": "乌兹别克斯坦", "tel": "998"},
                        ]
                    },
                    {
                        "initial": "X", "sections": [
                            {"name": "中国香港", "tel": "852"},
                            {"name": "西班牙", "tel": "34"},
                            {"name": "希腊", "tel": "30"},
                            {"name": "象牙海岸", "tel": "225"},
                            {"name": "新加坡", "tel": "65"},
                            {"name": "新喀里多尼亚", "tel": "687"},
                            {"name": "新西兰", "tel": "64"},
                            {"name": "匈牙利", "tel": "36"},
                            {"name": "叙利亚", "tel": "963"},
                        ]
                    },
                    {
                        "initial": "Y", "sections": [
                            {"name": "牙买加", "tel": "1876"},
                            {"name": "亚美尼亚", "tel": "374"},
                            {"name": "也门", "tel": "967"},
                            {"name": "伊拉克", "tel": "964"},
                            {"name": "伊朗", "tel": "98"},
                            {"name": "以色列", "tel": "972"},
                            {"name": "意大利", "tel": "39"},
                            {"name": "印度", "tel": "91"},
                            {"name": "印度尼西亚", "tel": "62"},
                            {"name": "英国", "tel": "44"},
                            {"name": "英属处女群岛", "tel": "1340"},
                            {"name": "约旦", "tel": "962"},
                            {"name": "越南", "tel": "84"},
                        ]
                    },
                    {
                        "initial": "Z", "sections": [
                            {"name": "中国", "tel": "86"},
                            {"name": "赞比亚", "tel": "260"},
                            {"name": "乍得", "tel": "235"},
                            {"name": "直布罗陀", "tel": "350"},
                            {"name": "智利", "tel": "56"},
                            {"name": "中非共和国", "tel": "236"},
                        ]
                    },
                ],
            }
        },
        created() {
            this.selectTel = this.$route.query.tel;
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                //获取上一个页面的名称
                vm.lastRouter = from.name;
            })
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === this.lastRouter && this.selectTel !== null && this.selectTel !== "") {
                to.query.tel = this.selectTel;
            }
            next();
        },
        methods: {
            countryClick(tel) {
                this.selectTel = tel;
                this.$router.go(-1);
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            }
        },
    }
</script>

<style scoped>
    .select_code {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .navigation {
        width: 100%;
        height: 44px;
        position: fixed;
        border-bottom: 1px solid #E5E3E3;
        background-color: white;
        z-index: 1000;
    }

    .navigation .left {
        float: left;
        width: 50px;
        height: 100%;
        color: #333333;
        font-size: 20px;
        text-align: center;
        line-height: 44px;
    }

    .navigation .content {
        float: left;
        height: 100%;
        width: calc(100% - 50px - 15px);
        text-align: center;
        line-height: 44px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }

    .navigation_back {
        width: 100%;
        height: 44px;
    }

    .country_item .anchor {
        padding-top: 44px;
        margin-top: -44px;
    }

    .country_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }

    .country_detail_item {
        position: relative;
        height: 50px;
    }

    .country_detail_item .country_name {
        position: absolute;
        text-align: left;
        font-size: 16px;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .country_detail_item .country_tel {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: #666666;
        font-size: 15px;
    }

    .country_detail_item .line {
        width: 100%;
        height: 1px;
        background-color: #e5e5e5;
    }

    .country_indexs {
        position: fixed;
        bottom: 100px;
        right: 0;
        z-index: 999;
    }

    .country_indexs .country_indexs_item {
        font-size: 10px;
        font-weight: bold;
        color: #1D89FF;
        height: 15px;
        width: 25px;
    }

</style>
